import { useState } from "react";

function useArtsListContainer() {
  const [selectedArtId, setSelectedArtId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedQuery, setSearchedQuery] = useState("");

  function onSelectArt(id) {
    setSelectedArtId(id);
  }

  function onSearchChange(e) {
    const { value } = e.target;

    setSearchQuery(value);
    if (value.length === 0 && searchedQuery) {
      setSearchedQuery("");
    }
  }

  function onSearchKeyDown(e) {
    const { key } = e;

    if (key === "Enter") {
      onSearch();
    }
  }

  function onSearch() {
    if (searchQuery !== searchedQuery) {
      setSearchedQuery(searchQuery);
    }
  }

  return {
    models: {
      selectedArtId,
      searchQuery,
      searchedQuery,
    },
    operations: {
      onSelectArt,
      onSearchChange,
      onSearchKeyDown,
      onSearch,
    },
  };
}

export default useArtsListContainer;
